module.exports = __webpack_public_path__ + "static/media/ex3.58916d07.jpg";